export enum CartClearReason {
  ADDING_STANDALONE = 'adding-standalone',
  CART_HAS_STANDALONE = 'cart-has-standalone',
}

export interface CartAddIntent {
  isStandalone: boolean;
}
